/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiExternalAdStatus;
(function (ApiExternalAdStatus) {
    ApiExternalAdStatus["EXTERNAL_AD_STATUS_NONE"] = "ExternalAdStatusNone";
    ApiExternalAdStatus["EXTERNAL_AD_STATUS_READY_TO_UPLOAD"] = "ExternalAdStatusReadyToUpload";
    ApiExternalAdStatus["EXTERNAL_AD_STATUS_UPLOADED"] = "ExternalAdStatusUploaded";
})(ApiExternalAdStatus || (ApiExternalAdStatus = {}));
export function ApiExternalAdStatusFromJSON(json) {
    return ApiExternalAdStatusFromJSONTyped(json, false);
}
export function ApiExternalAdStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiExternalAdStatusToJSON(value) {
    return value;
}
